export enum PanZoomActionEnum {
  ZOOM_IN,
  ZOOM_OUT
}
